import React from "react";
import { Link } from "react-router-dom";

export default function OurTeams() {
  const teamMembers = [
    {
      name: "Dr Sudarshan V",
      img: "/img/teams-08.png",
      exp: "10+ Years of Exp",
      spec: "MBBS,MS,FMAS,EFIAGE",
      desc: "MBBS, MS, FMAS, EFIAGES General and Laparoscopic surgeon. Is a compassionate and dedicated surgeon, with a keen eye for detail and precision.",
    },
    {
      name: "Aperna Tej",
      img: "/img/teams-02.png",
      exp: "15+ Years of Exp",
      spec: "Physiotherapist",
      desc: "Senior Physiotherapist with 15+ years of experience in joint care, musculoskeletal health, and geriatrics. She is also trained in treating stroke patients.",
    },
    {
      name: "Dr.Kritika Patel",
      img: "/img/teams-03.png",
      exp: "10+ Years of Exp",
      spec: "MBBS MD (Paediatrics)",
      desc: "MBBS MD (Paediatrics), Fellowship in Neonatology. Consultant Paediatrician and Neonatologist in several hospitals.",
    },
    {
      name: "Dr Sarita R.",
      img: "/img/teams-12.png",
      exp: "15+ Years of Exp",
      spec: "Obstetrician and Gynecologist",
      desc: "Obstetrician and gynecologist with 15+ years of experience. Trained in advanced laparoscopic procedures and member of minimal access surgery.",
    },
    {
      name: "Siddharth Sakelle",
      img: "/img/teams-04.png",
      exp: "20+ Years of Exp",
      spec: "BPT, Masters in Orthopedic",
      desc: "20+ years of experience in physiotherapy. Head Physiotherapist at Prakash Padukone Badminton Academy.",
    },{
      name: "Dr. Sharath .G",
      img: "/img/famPhy-team-15.jpg",
      exp: "12+ Years of Exp",
      spec: "ENT specialist",
      desc: "Fellowship in Rhinology and anterior skull base Surgery. ​He practices as a ENT specialist with 12 years of experience .​​",
    },{
      name: "Dr. Shantala.J​",
      img: "/img/famPhy-team-17.png",
      exp: "10+ Years of Exp",
      spec: "Fellowship in Pediatric",
      desc: "MBBS,DNB –Pediatrics with 10+ years of Experience ​Fellowship in Pediatric Endocrinology and Adolescent Endocrinology​ She is available in FamPhy Clinics everyday evening –Monday to Saturday on appointments ​",
    },{
      name: "Dr.Suhas CMV​",
      img: "/img/famPhy-team-18.jpg",
      exp: "5+ Years of Exp",
      spec: "M.S ENT​",
      desc: " Fellowship on balance and Vertigo​ He practices as a ENT specialist 5+ years of experience .​Specializes in FESS and other sinus Surgeries.",
    },{
      name: "Dr Manohar TH​",
      img: "/img/famPhy-team-19.jpg",
      exp: "Experienced ",
      spec: "MBBS,MS-Orthopaedics ​",
      desc: "Accomplished Orthopedic Surgeon with proficiency in complex trauma Joint replacement, Spine and Pediatric Procedures.​Skills Involve Hip and Knee Joint replacement​.",
    },{
      name: "Ms.Vrinda Pandey​",
      img: "/img/famPhy-team-20.png",
      exp: "18+ Years of Exp",
      spec: "Clinical Dietician and Health coach",
      desc: "Clinical Dietician and Health coach 18 years of Experience in diet Counselling.​ Worked with Corporate Hospitals and Educational Institutions.​",
    },{
      name: "Dr. Rajimol Raju",
      img: "/img/famPhy-team-21.png",
      exp: "Experienced",
      spec: "BPT(Physiotherapy)​",
      desc: " Specialized in Post Stroke Rehabilitation Expertise in restoring motor function and improving quality of life for stroke Survivors.​Expertise in Traumatic Brain Injury Rehabilitation.​",
    }


,{
      name: "Dr Priyanka S​",
      img: "/img/famPhy-team-22.jpg",
      exp: "15+ Years of Exp",
      spec: "Physician &Diabetologist",
      desc: "Physician &Diabetologist with special interest in Endocrinology with 15+ Years of experience​ MBBS, FEDM, FACE(USA), CCEBDM, CCGDM, CCMTD​ Has worked at several renowned hospitals​",
    },
{
      name: "Dr. Arshiya Tabassum​​",
      img: "/img/famPhy-team-23.png",
      exp: "10+ Years of Exp",
      spec: "MBBS ,MD Physician",
      desc: "MBBS ,MD Physician ​She is a medical graduate with 10 years of experience.​Worked in various Multispeciality Hospitals ​",
    },
{
      name: "Dr. Sannidhi​​",
      img: "/img/testimonials-icons-f.png",
      exp: "Experienced",
      spec: "MBBS,MS(Obstetrics & Gynecology)DNB​",
      desc: "Specialist in Obstetric Care and Gynecology​ Expertise in managing Postmenstrual Complaints and Hormonal imbalances​ Skilled in procedures such as Pap Smear and Preventive Screenings​",
    },




  ];

  return (
    <div className="container">
      <div className="ourteam-section">
        <h2>
          Our Team of <span>Doctors</span>
        </h2>
        <p className="limit-width">
          Specialized and general physicians who have many years of work
          experience in their respective fields
        </p>

        {/* Flexbox container */}
        <div className="team-flex">
          {teamMembers.map((doc, i) => (
            <div className="team-card" key={i}>
              <div className="teamimg">
                <img
                  className="img-fluid"
                  src={`${process.env.PUBLIC_URL}${doc.img}`}
                  alt={doc.name}
                />
              </div>
              <div className="teamcontent">
                <h5>{doc.name}</h5>
                <p>{doc.desc}</p>
                <div className="ext-content">
                  <span className="exp-yers">{doc.exp}</span>
                  <span className="mst-in">{doc.spec}</span>
                </div>
                <div className="team-btn-box">
                  <Link to="/contacts" className="btn theam-btn-m">
                    Consult
                  </Link>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>

    </div>
  );
}
